export default function (pathname) {
  return pathname !== '/';
}
